<div class="main-container" style="height: 100%;">

  <mat-sidenav-container class="example-sidenav-container">

    <!-- ===== SIDEBAR ===== -->
    <mat-sidenav #snav id="snav" class="dark-sidebar" [mode]="mobileQuery.matches ? 'side' : 'over'"
      fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" [(opened)]="opened">
      <app-nuevo-side></app-nuevo-side>
    </mat-sidenav>

    <mat-sidenav-content class="page-wrapper">

      <mat-toolbar class="topbar colorBack">

        <!-- Botón hamburguesa (siempre visible) -->
        <button id="snavButton" mat-mini-fab (click)="snav.toggle()" class="snav">
          @if (!opened) { <mat-icon>menu</mat-icon> }
          @if (opened) { <mat-icon>close</mat-icon> }
        </button>

        <!-- Logo — solo en móvil cuando el sidebar está cerrado -->
        @if (mobileQuery.matches && !opened) {
          <div class="navbar-header">
            <img src="./assets/images/Augajo/logo.png" alt="Augajo" class="imgLogoPrincipal">
          </div>
        }

        <!-- Empuja las acciones a la derecha -->
        <span class="topbar-spacer"></span>

        <!-- Perfil / logout / notificaciones -->
        <app-navbar class="floatRight"></app-navbar>

      </mat-toolbar>

      <!-- ===== CONTENIDO ===== -->
      <div class="page-content">
        <router-outlet>
          <app-spinner></app-spinner>
        </router-outlet>
      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
</div>